import * as types from '../constants/ActionTypes';
import { message } from "antd";
import { getEntries, deleteEvent } from "../services/firebase/events";
import { loadChannelsFromCache } from "../services/firebase/channels";
import { deleteVideoFromFirebase, deleteImageFromFirebase } from "../services/firebase/storage";
import Events from "../services/events";

// === GET ALL EVENTS and SORT ===
export function getEventsAction(claims, channels) {
  return (dispatch) => {
    return getEntries().then((events) => {
      dispatch(addEventsStatusLoadingStore(true));

      return sortEvents(events, claims, channels).then((eventsData) => {
        dispatch(addEventsStore(eventsData));

        return eventsData
      })
    });
  };
}

async function sortEvents(events, claims, channels) {
  let isAdmin = claims.userType === "Admin";
  let isContributor = claims.userType === "Contributor";

  let eventsWithVideos = events.filter(item => {
    // let isUpcoming = Events.isUpcoming(item.date);
    let isUploadVideo = item.uploadVideo && item.uploadVideo.uploadVideoUrl;

    if (item.isUpcoming || item.youTubeUrl ||  item.videoEmbed || item.playlist || isUploadVideo) {
      return item
    }
  });

  if (isAdmin) {
    let eventsWithoutVideos = (events && events.length) - (eventsWithVideos && eventsWithVideos.length)
    let messageText = '';
    if (eventsWithoutVideos && eventsWithoutVideos > 0) {
      messageText = `Please, specify video url for ${eventsWithoutVideos} past events`;
    }

    return { events: events, message: messageText}
  } else if(isContributor) {
    return filterEvents(events, claims, channels).then((result) => {
      let messageText = '';
      if (result.eventsFiltered && result.eventsFiltered.length > 0) {
        messageText = `Please, specify video url for ${result.eventsFiltered.length} past events`;
      }

      // return { events: result.eventModify, message: messageText }
      return { events: events, message: messageText }
    })
  } else {
    // return { events: eventsWithVideos, message: '' }
    return { events: events, message: '' }
  }
}

async function filterEvents(events, claims, channels) {
  if (channels && channels.length > 0) {
    return filtering(events, claims, channels)
  } else {
    return await loadChannelsFromCache(claims).then((channelsRes) => {
      return filtering(events, claims, channelsRes)
    }).catch((error) => message.error('Channel not found', error))
  }
}

function filtering(events, claims, channels) {
  let filteredEventsByChannelOwner = [];
  let modifyEventsListWithIsOwner = [];

  if (channels) {
    const ownChannel = channels.map((channel) => {
      if (channel.ownerId && channel.ownerId.find((id) => id === claims.user_id)) {
        return channel
      }
    }).filter(id => !!id);

    modifyEventsListWithIsOwner = events.map((item, i ) => {
      // let isUpcoming = Events.isUpcoming(item.date);
      let isUploadVideo = item.uploadVideo && item.uploadVideo.uploadVideoUrl;

      // ==> filter for events without videos and channel owner
      if(ownChannel[0] && ownChannel[0].id === item.channel.id && !item.youTubeUrl && !item.isUpcoming && !isUploadVideo) {
        filteredEventsByChannelOwner.push(item)
      }
      // ==> add a trigger for events if it's events of this contributor
      if (ownChannel[0] && ownChannel[0].id === item.channel.id) {
        item.isContributor = true
      }

      return item
    });

    return {
      eventsFiltered: filteredEventsByChannelOwner || [],
      eventModify: modifyEventsListWithIsOwner || []
    }
  }
}

export function addEventsStore(payload) {
  return {
    type: types.ADD_EVENTS,
    payload,
  };
}

export function addEventsStatusLoadingStore(payload) {
  return {
    type: types.EVENTS_LOADING,
    payload,
  };
}

// === DELETE EVENT ===
export function deleteEventAction(event) {
  return (dispatch) => {
    return deleteEvent(event).then((res) => {
      if (res === "success") {
        event.thumbnailName && deleteImageFromFirebase(event.thumbnailName);
        event.uploadVideo && event.uploadVideo.fileName && deleteVideoFromFirebase(event.uploadVideo.fileName);
        dispatch(deleteEventStore(event));

        return "success"
      }
    });
  };
}

export function deleteEventStore(payload) {
  return {
    type: types.DELETE_EVENT,
    payload,
  };
}

// === ADD EVENT ===
export function addEventAction(event) {
  return (dispatch) => {
    dispatch(addEventStore(event));
  };
}

export function addEventStore(payload) {
  return {
    type: types.ADD_EVENT,
    payload,
  };
}

// === UPDATE EVENT ===
export function updateEventAction(event) {
  return (dispatch) => {
    dispatch(updateEventStore(event));
  }
}

export function updateEventStore(payload) {
  return {
    type: types.UPDATE_EVENT,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/actions/eventsStoreActions.js